import type { SelectOption } from "@/components/tables/fields/selectOptions";

type Translate = (key: string) => string;

export interface SedDepartmentLockInput {
  entityOfTable?: string;
  entity?: string;
  createSedForCompany: unknown;
  subjectSet: any;
}

export const isSedDepartmentSelectionLocked = ({
  entityOfTable,
  entity,
  createSedForCompany,
  subjectSet,
}: SedDepartmentLockInput) =>
  entityOfTable === "subjectExaminationDeadline" &&
  entity === "department" &&
  (createSedForCompany === true ||
    (subjectSet?.length !== 0 && subjectSet !== null)); // preserved quirk: an unset person list locks as well

export const isDepartmentManagerOption = (option: SelectOption, t: Translate) =>
  option.label === t("department_manager"); // the department manager role is deactivated; matching by label also blocks the group of that name
